import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useContext, useEffect, useState } from 'react';
import { Alert, Button, ButtonGroup, CloseButton, Container, FloatingLabel, Form, Image, InputGroup, ProgressBar, Spinner, Tab, Tabs, ToggleButton } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { LinkContainer } from 'react-router-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { LoginInfo } from '../App';
import ImageFile from '../domain/ImageFile';
import * as ImageUtil from '../service/ImageUtil';
import ApiFetch from './ApiFetch';
import CampaignMessage from './CampaignMessage';
import Category from './Category';
import Dialog from './Dialog';
import Footer from './Footer';
import Header from './Header';
import { useTranslation } from "react-i18next";
import MosaicEditPopup from './MosaicEditPopup';

const EventEditPopup = (props) => {
    async function getImageInfo(groupId){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/event/infoLatest/"+groupId).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function deleteImage(groupId){
        return await new ApiFetch().delete(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/event/post/"+groupId).then((r)=>r.json().then((d)=>{
            return d
        }))
    }
    const {t,i18n} = useTranslation()
    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)
    // ナビゲーション
    const navigate = useNavigate()

    // 年齢制限
    const [ageLimit,setAgeLimit] = useState("")
    const [sexualExpression,setSexualExpression] = useState('')

    // 画像情報
    const [imageInfo,setImageInfo] = useState({info:{id:"",title:"",description:""}});
    const [imageInfoStatus,setImageInfoStatus] = useState(false);
    const [detailId,setDetailId] = useState(0)

    const [fromDate,setFromDate] = useState("")
    const [fromTime,setFromTime] = useState("")
    const [toDate,setToDate] = useState("")
    const [toTime,setToTime] = useState("")

    // パラメータ
    const param = useParams()
    let groupId = props.groupId

    // 画像遅延ロード
    const options = {
        root: null,
        rootMargin: "0px",
        threshold: 0.05
    }

    const observer = new IntersectionObserver((entries,observer)=>{
        entries.forEach(entry => {
            if(entry.intersectionRatio > 0){
                const imgEl = entry.target;
                imgEl.src = imgEl.dataset.src;          
                observer.unobserve(entry.target);
              }
        })
    }, options);

    function edit(groupId,title,description,limitedPublication,place,fromDatetime,toDatetime,price,access,url,contact){
        setSaving(true)
        new ApiFetch().put(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/upload/event",
            {groupId:groupId,title:title,description:description,
                limitedPublication:limitedPublication,
                ageLimit:ageLimit,sexualExpression:sexualExpression,styleOfPainting:styleOfPainting,place:place,
                fromDatetime:fromDatetime,toDatetime:toDatetime,price:price,access:access,url:url,contact:contact}).then((r)=>{
            return r.json().then((json)=>{
                if(json.result){
                    dialog(t("common.confirm"),"更新が完了しました。")
                } else {
                    dialog(t("common.error"),json.errors.join("\r\n"))
                }
                setSaving(false)
                return json.result
            })
        })
    }

    useEffect(() => {
        // タイトル設定
        //document.querySelector("title").textContent = t("common.edit") + " - " + t("common.siteName")
        getImageInfo(groupId).then(r => {
            if(r.result){
                setImageInfo(r)
                setImageInfoStatus(true)
                setAgeLimit(String(r.info.age_limit))
                setSexualExpression(String(r.info.sexual_expression))
                setStyleOfPainting(String(r.info.style_of_painting))
                let fromSplit = r.info.from_datetime.split(" ")
                setFromDate(fromSplit[0])
                setFromTime(fromSplit[1])
                let toSplit = r.info.to_datetime.split(" ")
                setToDate(toSplit[0])
                setToTime(toSplit[1])
            }
        })
    },[groupId])

    // ダイアログ
    const [show, setShow] = useState(false);
    const [dialogTitle, setDialogTitle] = useState("");
    const [dialogMessage, setDialogMessage] = useState("");
    function dialog(title,message){
        setDialogTitle(title)
        setDialogMessage(message)
        setShow(true)
    }

    // 画像遅延ロード
    useEffect(() => {
        //document.querySelectorAll(".lazy").forEach(e => observer.observe(e))
    },[imageInfo,groupId])

    // エラーメッセージ
    const [message, setMessage] = useState('');
    const [messageShow, setMessageShow] = useState('none');

    const nenrei = [
        { name: t("upload.image.ageLimit1"), value: '1' },
        { name: t("upload.image.ageLimit2"), value: '2' },
        { name: t("upload.image.ageLimit3"), value: '3' }
    ];

    const yesOrNoRadio = [
        { name: t("common.yes"), value: "1" },
        { name: t("common.no"), value: "2" },
    ];

    const [showMosaicEditPopup,setShowMosaicEditPopup] = useState(false)
    const [saving,setSaving] = useState(false)
    document.onkeydown = (e) => {
        if(e.key === "Escape"){
            props.switch(false)
        }
    }

    const [styleOfPainting, setStyleOfPainting] = useState('')
    const styles = [
        { name: t("upload.image.illustration"), value: '1' },
        { name: t("upload.image.semirealism"), value: '3' },
        { name: t("upload.image.photorealistic"), value: '2' },
    ]

    return (
    <div style={{position:"fixed",top:0,left:0,width:"100%",height:"100%",backgroundColor:"#000000",zIndex:4}}>
        <Dialog title={dialogTitle} message={dialogMessage} show={show} handleClose={() => setShow(false)} />
        {showMosaicEditPopup ? <MosaicEditPopup type="event" switch={setShowMosaicEditPopup} groupId={groupId} detailId={detailId} /> : ""}
        <div id="edit-popup" style={{position:"fixed",top:"1%",left:"1%",width:"98%",height:"98%",zIndex:5,overflow:"auto",backgroundColor:"#FFFFFF",borderRadius:"20px"}}>
        <Button variant='secondary' className='m-3' style={{position:"fixed",left:"14px",zIndex:1}} onClick={() => props.switch(false)}>{t("common.close")}</Button>
        <Container className='d-flex flex-row justify-content-center flex-wrap' style={{marginTop:"60px",marginBottom:"200px"}}>
            <Tabs defaultActiveKey="account" id="uncontrolled-tab-example" className="mt-3 mb-3 w-100 d-flex" style={{flexWrap: "nowrap",alignItems:"stretch"}}>
                <Tab eventKey="account" title={t("upload.event.title")} style={{position:"relative",flex:"1"}}>
                    {imageInfoStatus && imageInfo.detail.length > 0 ? (
                    <Container className="d-flex justify-content-start align-items-center" style={{flexWrap:"wrap",width:"100%",padding:"5px",backgroundColor:"#FFFFFF",border:"1px solid #CCCCCC",borderRadius:"5px"}}>
                        {imageInfo.detail.map((d,i) => {
                            return (
                                <div style={{position:"relative",flexShrink:0,width:"100px",height:"100px",overflow:"hidden"}} className="m-1" key={d.id}>
                                    <Icon.PencilFill style={{color:"#0000FF",fontSize:"24px",position:"absolute",right:"5px",top:"5px",borderRadius:"20px",backgroundColor:"#FFFFFF",cursor:"pointer"}}
                                        onClick={(e) => {
                                        setShowMosaicEditPopup(true)
                                        setDetailId(d.id)
                                    }} title={t("common.editMosaic")} />
                                    <Image src={"http://"+ApiFetch.IMG_HOST+"/event/post/t/"+d.id+".jpg"} style={{objectFit:"cover",width:"100%",height:"100%"}} className="lazy" />
                                </div>
                            )
                        })}
                    </Container>
                    ) : ""}
                    <pre style={{backgroundColor:"#555555",color:"#FFFFFF",padding:"10px",borderRadius:"5px",display:messageShow}}>{message}</pre>
                    <Form style={{margin:"0 auto",position:"relative",width:"100%",marginTop:"20px"}}>
                        <FloatingLabel controlId="title" label={t("upload.image.imageTitle")} className="mb-3 w-100">
                            <Form.Control type="text" placeholder="" required defaultValue={imageInfo.info.title} />
                        </FloatingLabel>                        
                        <FloatingLabel controlId="description" label={t("upload.image.imageDescription")} className='mb-3 w-100'>
                            <Form.Control
                                as="textarea"
                                style={{ height: '100px' }}
                                required
                                defaultValue={imageInfo.info.description}
                            />
                        </FloatingLabel>
                        <FloatingLabel controlId="place" label={"開催場所詳細"} className="mt-3 mb-3 w-100">
                            <Form.Control
                                as="textarea"
                                style={{ height: '100px' }}
                                required
                                defaultValue={imageInfo.info.place}
                            />
                        </FloatingLabel>
                        <Container className='p-0'>
                            開催日
                            <div className='d-flex justify-content-center'>
                                <FloatingLabel controlId="from-date" className='mb-3 w-100'>
                                    <Form.Control
                                        type="date"
                                        required
                                        defaultValue={fromDate}
                                        onChange={(e) => setFromDate(e.currentTarget.value)}
                                    />
                                </FloatingLabel>
                                <FloatingLabel controlId="from-time" className='mb-3 w-100'>
                                    <Form.Control
                                        type="time"
                                        required
                                        defaultValue={fromTime}
                                        onChange={(e) => setFromTime(e.currentTarget.value)}
                                    />
                                </FloatingLabel>
                                ～
                                <FloatingLabel controlId="to-date" className='mb-3 w-100'>
                                    <Form.Control
                                        type="date"
                                        required
                                        defaultValue={toDate}
                                        onChange={(e) => setToDate(e.currentTarget.value)}
                                    />
                                </FloatingLabel>
                                <FloatingLabel controlId="to-time" className='mb-3 w-100'>
                                    <Form.Control
                                        type="time"
                                        required
                                        defaultValue={toTime}
                                        onChange={(e) => setToTime(e.currentTarget.value)}
                                    />
                                </FloatingLabel>
                            </div>
                            <Button className="mb-3" onClick={() => {
                                document.getElementById("from-date").value = ""
                                document.getElementById("from-time").value = ""
                                document.getElementById("to-date").value = ""
                                document.getElementById("to-time").value = ""
                                setFromDate("")
                                setFromTime("")
                                setToDate("")
                                setToTime("")
                            }}>開催日の入力をクリア</Button>
                        </Container>
                        <FloatingLabel controlId="price" label={"料金"} className="mb-3 w-100">
                            <Form.Control
                                as="textarea"
                                style={{ height: '100px' }}
                                required
                                defaultValue={imageInfo.info.price}
                            />
                        </FloatingLabel>
                        <FloatingLabel controlId="access" label={"交通アクセス"} className="mb-3 w-100">
                            <Form.Control
                                as="textarea"
                                style={{ height: '100px' }}
                                required
                                defaultValue={imageInfo.info.access}
                            />
                        </FloatingLabel>
                        <FloatingLabel controlId="url" label={"公式サイト"} className="mb-3 w-100">
                            <Form.Control type="text" placeholder="" required autoComplete="new-password" defaultValue={imageInfo.info.url} />
                        </FloatingLabel>
                        <FloatingLabel controlId="contact" label={"問い合わせ先"} className="mb-3 w-100">
                            <Form.Control
                                as="textarea"
                                style={{ height: '100px' }}
                                required
                                defaultValue={imageInfo.info.contact}
                            />
                        </FloatingLabel>
                        <InputGroup className="mb-3" style={{maxWidth:"360px"}}>
                            <InputGroup.Checkbox style={{cursor:"pointer"}} id="limited-publication" defaultChecked={imageInfo.info.limited_publication} />
                            <Form.Control type="text" value={t("upload.image.limitedPublication")} readOnly />
                        </InputGroup>
                        {loginInfo.role && loginInfo.role.find(d => d.role_div === "admin" || d.role_div === "moderator") && imageInfo.info.user_id !== loginInfo.userId ? (
                        <Container style={{color:"red",fontWeight:"bold",fontSize:"24px",border:"3px solid red"}} className="mb-3">
                            管理者権限で編集中です。
                        </Container>
                        ) : ""}
                        <Button onClick={(e) => {
                            // 問題ない場合は文字列を返す
                            function checkString(id,name,length){
                                let elm = document.getElementById(id)
                                let str = elm.value.trim()
                                if(str.length > length){
                                    dialog(t("common.error"),name + "の上限は"+length+"文字です。")
                                    return false
                                }
                                return str
                            }
                            function createDateTime(date,time){
                                let datetime = ""
                                if(date.length > 0 && time.length > 0){
                                    datetime = date + " " + time
                                } else {
                                    datetime = ""
                                }
                                return datetime
                            }
                            let title = document.getElementById("title")
                            let description = document.getElementById("description")
                            if(title.value.trim().length === 0 ){
                                dialog(t("common.error"),"タイトルを入力して下さい。")
                                return false
                            }
                            /*if(description.value.trim().length === 0){
                                dialog("エラー","概要を入力して下さい。")
                                return false
                            }*/
                            if(ageLimit === ""){
                                dialog(t("common.error"),"年齢制限を指定して下さい。")
                                return false
                            }
                            // 全年齢の場合、性的表現について必須
                            if(ageLimit === "1"){
                                if(sexualExpression === "0"){
                                    dialog(t("common.error"),"性的表現を指定して下さい。")
                                    return false
                                }
                            } else if(ageLimit === "2" || ageLimit === "3"){
                                if(sexualExpression !== "0"){
                                    dialog(t("common.error"),"年齢制限がR18,R18G指定の場合、性的表現の選択は不要です。")
                                    return false
                                }
                            }
                            let descriptionStr = description.value.trim()
                            let place = checkString("place","開催場所詳細",50000)
                            let fromDatetime = createDateTime(fromDate,fromTime)
                            let toDatetime = createDateTime(toDate,toTime)
                            let limitedPublication = document.getElementById("limited-publication").checked ? "1" : "0"
                            let price = checkString("price","料金",50000)
                            let access = checkString("access","交通アクセス",50000)
                            let url = checkString("url","交通アクセス",50000)
                            let contact = checkString("contact","お問い合わせ",50000)
                            edit(groupId,title.value.trim(),descriptionStr,limitedPublication,place,fromDatetime,toDatetime,
                            price,access,url,contact)
                        }}>{t("common.update")}</Button>
                        {saving ? (
                            <Spinner animation="border" size="sm" style={{marginLeft:"10px"}} />
                        ) : ""}
                        <Button variant='danger' style={{marginLeft:"10px"}} onClick={()=>{
                            dialog(t("common.confirm"),
                                <Container className='text-center' style={{margin:"0 auto"}}>
                                    <Container>{t("common.delete")}</Container>
                                    <Button
                                    onClick={() => {
                                        deleteImage(groupId).then(r=>{
                                            if(r.result){
                                                dialog(t("common.confirm"),t("common.deleted"))
                                            } else {
                                                dialog(t("common.error"),r.errors)
                                            }
                                        })
                                    }}
                                    >{t("common.deleteStr")}</Button>
                                </Container>
                                )
                        }}>{t("common.deleteStr")}</Button>
                    </Form>
                </Tab>
            </Tabs>
        </Container>
        </div>
    </div>
    )
}

export default EventEditPopup;
